import { Star } from 'lucide-react';
import type { MouseEvent } from 'react';

import { Button } from '@/_shared/components/ui/button';
import { cn } from '@/_shared/lib/utils';

interface StarToggleButtonProps {
  dashboardTitle: string;
  starred: boolean;
  onToggle: () => void;
  loading?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function StarToggleButton({
  dashboardTitle,
  starred,
  onToggle,
  loading = false,
  className,
  size = 'md',
}: StarToggleButtonProps): React.ReactElement {
  const label = starred ? `Unstar dashboard ${dashboardTitle}` : `Star dashboard ${dashboardTitle}`;

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    if (loading) return;
    onToggle();
  };

  return (
    <Button
      type="button"
      variant="tertiary"
      size={size}
      aria-label={label}
      title={label}
      aria-pressed={starred}
      loading={loading}
      onClick={handleClick}
      Icon={<Star className={cn(starred ? 'fill-current text-primary' : 'text-muted-foreground')} />}
      className={cn(starred && 'text-primary', loading && 'opacity-50', className)}
    />
  );
}
